import ExcelJS from "exceljs";
import { downloadWorkbook } from "../../ExportExcelButtonV3/utils";
import { sanitizeFileName } from "utils/sanitizeFileName";
import type { ExportBoqPositionsArgs } from "./types";

export const exportBoqPositions = async ({
  positions,
  projectName,
  headers,
}: ExportBoqPositionsArgs) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Monco Application";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet(headers.sheetName);

  sheet.columns = [
    { header: headers.position, key: "position", width: 16 },
    { header: headers.description, key: "description", width: 50 },
    { header: headers.quantity, key: "quantity", width: 12 },
    { header: headers.unit, key: "unit", width: 10 },
    { header: headers.section, key: "section", width: 30 },
    { header: headers.category, key: "category", width: 20 },
    { header: headers.specs, key: "specs", width: 30 },
    { header: headers.articleNumber, key: "articleNumber", width: 18 },
    { header: headers.manufacturer, key: "manufacturer", width: 20 },
  ];

  const headerRow = sheet.getRow(1);
  headerRow.height = 22;
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF2F5233" },
    } as ExcelJS.FillPattern;
    cell.alignment = { vertical: "middle", horizontal: "left" };
    cell.border = {
      bottom: { style: "thin", color: { argb: "FFBFBFBF" } },
    };
  });

  for (const p of positions) {
    sheet.addRow({
      position: p.position_number || "",
      description: p.description || "",
      quantity: p.quantity ?? "",
      unit: p.unit || "",
      section:
        p.section_name || p.section_title
          ? `${p.section_number ? p.section_number + " " : ""}${p.section_name || p.section_title || ""}`
          : p.section_number || "",
      category: p.category || "",
      specs: p.specs || "",
      articleNumber: p.article_number || "",
      manufacturer: p.manufacturer || "",
    });
  }

  // Style data rows
  for (let i = 2; i <= positions.length + 1; i++) {
    const row = sheet.getRow(i);
    const isEven = i % 2 === 0;
    row.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: isEven ? "FFF8F9FA" : "FFFFFFFF" },
      } as ExcelJS.FillPattern;
      cell.alignment = { vertical: "middle" };
      cell.border = {
        bottom: { style: "thin", color: { argb: "FFE9ECEF" } },
      };
    });
  }

  // Freeze header row
  sheet.views = [
    {
      state: "frozen",
      xSplit: 0,
      ySplit: 1,
      topLeftCell: "A2",
      activeCell: "A2",
    },
  ];

  // Auto filter
  const lastCol = sheet.getColumn(sheet.columns.length).letter;
  sheet.autoFilter = { from: "A1", to: `${lastCol}${positions.length + 1}` };

  const nameSlug = sanitizeFileName({
    rawName: projectName || "boq",
    fallback: "boq",
  });
  const date = new Date().toISOString().split("T")[0];
  await downloadWorkbook(workbook, `${nameSlug}_boq_positions_${date}.xlsx`);
};
